import { Phone, ArrowRight } from "lucide-react";

export default function MobileStickyBar() {
  return (
    <div
      data-testid="mobile-sticky-bar"
      className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-[#0260B8]/95 backdrop-blur-xl border-t border-white/10 px-4 py-3 safe-area-bottom"
    >
      <div className="flex gap-3">
        <a
          href="tel:+33695134999"
          data-testid="mobile-call-btn"
          className="flex items-center justify-center gap-2 flex-1 bg-white/10 border border-white/20 text-white font-bold py-3 rounded-full text-sm transition-all active:scale-95"
        >
          <Phone className="w-4 h-4" />
          Appeler
        </a>
        <a
          href="#contact"
          data-testid="mobile-cta-btn"
          onClick={(e) => {
            e.preventDefault();
            document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
          }}
          className="flex items-center justify-center gap-2 flex-[2] bg-white text-[#0284FC] font-bold py-3 rounded-full text-sm transition-all active:scale-95"
        >
          Je veux transformer ma cuisine
          <ArrowRight className="w-4 h-4" />
        </a>
      </div>
    </div>
  );
}
